import { render, staticRenderFns } from "./localization-autocomplete.vue?vue&type=template&id=1f1b7605&"
import script from "./localization-autocomplete.vue?vue&type=script&lang=js&"
export * from "./localization-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports